import { VStack } from '@chakra-ui/react';
import { Select } from 'chakra-react-select';
import { Field } from 'formik';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { dropDownFormStyle } from 'components/forms/new/formStyles';

import config from '@/config.json';

const MonthFormatField = ({ values, setFieldValue, FormFieldWithTooltip }) => {
    const { darkMode } = useSelector((state) => state.settings);

    const monthOptions = useMemo(
        () =>
            config.datetime.month.map((month) => ({
                ...month,
                id: month.name,
            })),
        [],
    );

    return (
        <FormFieldWithTooltip
            label="Month"
            tooltipLabel="Select the format for displaying the month (e.g., 'Jan', 'January', '01')."
            fieldKey="month">
            <Field>
                {({ field }) => (
                    <VStack width="100%" alignItems="normal">
                        <Select
                            {...field}
                            tabSelectsValue
                            openMenuOnFocus
                            options={monthOptions}
                            value={monthOptions.find(
                                (o) => o.id === values?.timeZone?.month,
                            )}
                            getOptionLabel={(o) => o.value}
                            getOptionValue={(o) => o.id}
                            chakraStyles={dropDownFormStyle(darkMode)}
                            onChange={(e) => {
                                setFieldValue('timeZone', {
                                    ...values?.timeZone,
                                    month: e.name,
                                });
                            }}
                            selectedOptionColor="brand"
                            size="md"
                        />
                    </VStack>
                )}
            </Field>
        </FormFieldWithTooltip>
    );
};

export default MonthFormatField;
